import React, { useContext } from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../../../Buttons/PlainButtonOrLink';
import { BiDataHook, BiEventType } from '../../../biLogger/constants';
import GiveBadgeIcon from '../../../Icons/GiveBadge';
import { CommentContext } from '../CommentContext';
import { ResourceType } from '../../../types/resource';
import s from './AwardBadgeButton.scss';
var AwardBadgeButton = function (_a) {
    var className = _a.className, disabled = _a.disabled, awardBadge = _a.awardBadge;
    var comment = useContext(CommentContext).comment;
    return (React.createElement(PlainButtonOrLink, { className: classnames(s['badge-button'], className), onClick: function () {
            return awardBadge({
                itemId: comment.commentId,
                typeId: ResourceType.COMMENT,
                user: comment.user,
                comment: comment,
            });
        }, disabled: disabled, "data-hook": BiDataHook.COMMENT_BADGE_BUTTON, biData: {
            evid: BiEventType.GIVE_BADGE_AWARD,
            sectionname: 'comments',
            typeid: ResourceType.COMMENT,
            itemid: comment.commentId,
        } },
        React.createElement(GiveBadgeIcon, { className: s['badge'], customSizable: true, disableDefaultColors: true })));
};
AwardBadgeButton.displayName = 'AwardBadgeButton';
export default AwardBadgeButton;
//# sourceMappingURL=AwardBadgeButton.js.map